import Button from '../Button'
import Reveal from '../Reveal'
import { Section, SectionHead } from '../Section'
import { initials } from '../../lib/format'

/**
 * "Kundenstimmen" - shown on the home page and /ueber-uns.
 *
 * The six entries are the ones the old site published, quoted as they stood:
 * only punctuation and the author split were fixed, because the export ran the
 * closing word into the name. No star ratings - the original showed none, so
 * five gold stars per card would be a rating nobody gave.
 */

const QUOTES = [
  {
    title: 'Empfehlung!',
    body: 'Seriöse und zuverlässige Hausverwaltung! Kann die Verwaltung wärmstens empfehlen.',
    author: 'L. Weinberger',
  },
  {
    title: 'Super Betreuung',
    body: 'Super!!! Keine leeren Versprechen!',
    author: 'Mathilda Schönfeld',
  },
  {
    title: 'Sorgenfrei',
    body: 'Seit Jahren hatte ich immer wieder Probleme mit benachbarten Objekten, nicht zuletzt wegen der schwierigen Parkplatzsituation. Als Eigentümer fiel das immer auf mich zurück. Das Problem wurde mit den richtigen Ansätzen und Fingerspitzengefühl nach und nach endlich gelöst.',
    author: 'Konrad M.',
  },
  {
    title: 'Ich bin sehr zufrieden',
    body: 'Hier erhält man immer zügig eine Rückantwort, weiter so.',
    author: 'Anneliese Grubenbach',
  },
  {
    title: 'Gute Arbeit',
    body: '2018 haben wir in Albstadt nicht nur ein Mehrfamilienhaus geerbt, sondern auch die Verpflichtungen. Es war immer ein organisatorischer Aufwand, wer nun zum Objekt fährt, welcher Makler bei Auszug beauftragt wird etc. Dazu kamen noch die alltäglichen Aufgaben, die ein Mehrfamilienhaus mit sich bringt. Mit Casa haben wir hier den richtigen Partner vor Ort gefunden - saubere Arbeit.',
    author: 'Friedrich S.',
  },
  {
    title: 'Top Service',
    body: 'Ich bin mit dem Service wirklich sehr zufrieden. Ist heutzutage leider eine Seltenheit. Uneingeschränkte Empfehlung meinerseits!',
    author: 'Otto Schwarzberg',
  },
]

export default function Testimonials() {
  return (
    <Section tone="paper">
      <SectionHead
        eyebrow="Kundenstimmen"
        title="Feedbacks aus erster Hand"
        lead="Rückmeldungen von Eigentümern, deren Objekte wir betreuen."
        center
      />

      <Reveal className="quote-grid">
        {QUOTES.map((item) => (
          <figure className="quote" key={item.author}>
            <span className="quote__mark" aria-hidden="true">
              &ldquo;
            </span>
            <h3 className="quote__title">{item.title}</h3>
            <blockquote className="quote__body">
              <p style={{ margin: 0 }}>{item.body}</p>
            </blockquote>
            <figcaption className="quote__author">
              <span className="quote__avatar" aria-hidden="true">
                {initials(item.author)}
              </span>
              <strong>{item.author}</strong>
            </figcaption>
          </figure>
        ))}
      </Reveal>

      <div
        className="btn-row"
        style={{ marginTop: 'var(--s-6)', justifyContent: 'center' }}
      >
        <Button to="/kontakt" variant="outline" icon="arrowRight">
          Feedback abgeben
        </Button>
      </div>
    </Section>
  )
}
